import request from "@utils/request";

export function getMTDPnl(query) {
    return request({
        url: "statistic/mtd-pnl",
        method: "post",
        data: query
    });
}
